import React from 'react';
import { OnboardingStepGate } from '../../components/OnboardingStepGate';
import { ROUTES_PATH } from '../../constants/Routes';
import { useOnboardingAddress } from './useOnboardingAddress';

interface OnboardingAddressGateProps {
  children: React.ReactNode;
  isExempt?: boolean;
}

export function OnboardingAddressGate({
  children,
  isExempt,
}: OnboardingAddressGateProps) {
  const { status } = useOnboardingAddress();

  return (
    <OnboardingStepGate
      status={status}
      stepPath={ROUTES_PATH.ONBOARDING.ADDRESS}
      isExempt={isExempt}
    >
      {children}
    </OnboardingStepGate>
  );
}
